import { SearchX } from "lucide-react";
import { Link } from "react-router-dom";

import { useAuth } from "@/auth/AuthProvider";
import { homePath } from "@/auth/roles";
import { EmptyState, LinkButton } from "@/ui";

import s from "./AppShell.module.css";

/** An address inside the console that leads nowhere: say so, and offer the way home. */
export function NotFound() {
  const { user } = useAuth();
  return (
    <div className={s.notFound}>
      <EmptyState
        heading="h1"
        icon={<SearchX />}
        title="Page not found"
        text="The address may be mistyped, or the page has moved. Nothing has changed in your organisation."
        action={<LinkButton as={Link} to={user ? homePath(user.role) : "/login"} variant="primary">Go to your start page</LinkButton>}
      />
    </div>
  );
}
